import React from 'react';
import { skillsData } from '../../data/skillsData';
import './Skills.css';

function Skills() {
  const row1 = [...skillsData, ...skillsData];
  const row2 = [...skillsData, ...skillsData].reverse();

  return (
    <section className="skills-section" id="skills">
      <div className="skills-header">
        <h2 className="section-title">tech arsenal</h2>
        <p className="section-sub">The stack I ship production software with — scrolling like a live ticker.</p>
      </div>

      <div className="marquee-wrap" aria-label="Skills marquee">
        <div className="marquee-row marquee-left">
          <div className="marquee-track">
            {row1.map((skill, i) => (
              <span key={`a-${i}`} className="marquee-word">{skill}</span>
            ))}
          </div>
        </div>

        <div className="marquee-row marquee-right">
          <div className="marquee-track">
            {row2.map((skill, i) => (
              <span key={`b-${i}`} className="marquee-word">{skill}</span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Skills;
